import { Autocomplete as AutocompleteMantine, type AutocompleteProps } from '@mantine/core'

type TProps = AutocompleteProps

export const Autocomplete: React.FC<TProps> = (props) => <AutocompleteMantine {...props} />
